<template lang="pug">
#header
  v-app-bar(color="green accent-5" dense dark)
    v-toolbar-title
      router-link.header-link(v-bind:to="'/'") {{ $t("top.title") }} 〜 Stay Home, Save Lives, and Type Well 〜
    v-spacer
    v-col#lang-switch(cols="2" v-if="isTop()")
      v-select(height="30" @changed="changeLanguage()" single-line menu-props="auto" prepend-icon="translate" v-model="selectedLang" item-text="label" item-value="value" id="lang-select" :items="items" label="Standard")
</template>

<script>
export default {
  data: function () {
    return {
      selectedLang: 'ja',
      items: [
        { label: '日本語', value: 'ja' },
        { label: 'English', value: 'en' }
      ]
    }
  },
  created: function () {
    if (localStorage.locale) {
      this.selectedLang = localStorage.locale
    }
  },
  methods: {
    isTop: function () {
      return this.$route.path === '/'
    }
  },
  watch: {
    selectedLang: function (value) {
      localStorage.locale = value
      this.$i18n.locale = value
    }
  }
}
</script>

<style>

.header-link {
  color: white !important;
  text-decoration: none;
  font-weight: bold;
}

#lang-switch {
  height: 50px;
  color: white;
  font-weight: bold;
}

</style>



// WEBPACK FOOTER //
// src/components/common/Header.vue